export default "__VITE_ASSET__BPSh8n2r__"